import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const BARS = [0.5, 0.8, 0.35, 1, 0.65, 0.9, 0.45, 0.75, 0.3, 0.85, 0.55, 0.7];

function Mark() {
  return (
    <div className="lg-mark">
      <svg viewBox="0 0 132 132">
        <defs>
          <linearGradient id="lg-mark-fill" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#1c1530" />
            <stop offset="1" stopColor="#0d0a16" />
          </linearGradient>
        </defs>
        <g className="lg-ring-spin">
          <circle cx="66" cy="66" r="63" fill="none" stroke="rgba(196,181,253,0.28)" strokeWidth="1" strokeDasharray="2 7" />
          <circle cx="66" cy="3" r="3" fill="#c4b5fd" />
        </g>
        <g className="lg-ring-spin-rev">
          <circle cx="66" cy="66" r="54" fill="none" stroke="rgba(139,92,246,0.5)" strokeWidth="1" strokeDasharray="60 280" strokeLinecap="round" />
        </g>
        <rect x="26" y="26" width="80" height="80" rx="20" fill="url(#lg-mark-fill)" stroke="rgba(196,181,253,0.4)" strokeWidth="1.25" />
        <path className="lg-m-path" d="M45 84V48l21 21 21-21v36" fill="none" stroke="#fdfcff" strokeWidth="5.5" strokeLinejoin="round" strokeLinecap="round" />
        <rect x="80" y="80" width="9" height="9" rx="2.5" fill="#8b5cf6" />
      </svg>
    </div>
  );
}

export default function LoginBrand() {
  const reduce = useReducedMotion();
  const rise = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 26 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
  });
  return (
    <section className="lg-brand" data-testid="login-brand">
      <div className="lg-lockup">
        <motion.div {...rise(0.05)} initial={{ opacity: 0, scale: reduce ? 1 : 0.85 }} animate={{ opacity: 1, scale: 1 }}><Mark /></motion.div>
        <motion.h2 className="lg-word" {...rise(0.18)} aria-label="Mario IA Tech">
          <span aria-hidden="true">MARIO</span><br /><span aria-hidden="true" className="lg-word-ia">IA</span>
        </motion.h2>
        <motion.p className="lg-word-tech" {...rise(0.32)} aria-hidden="true">TECH</motion.p>
        <motion.div className="lg-bars hidden lg:flex" {...rise(0.46)} aria-hidden="true">
          {BARS.map((h, i) => <span key={i} style={{ height: `${h * 100}%`, animationDelay: `${-i * 0.23}s` }} />)}
        </motion.div>
      </div>
    </section>
  );
}
